<template>
  <v-container fluid class="sasv pa-0">
    <v-navigation-drawer permanent
                         expand-on-hover>
      <v-list dense>
        <v-list-item :to="{name: 'sasv'}" v-if="$hasPermission('sasv.list')" exact>
          <v-list-item-icon>
            <v-icon>far fa-id-card</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('admin_sasv.title') }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{name: 'sasv-duplicate'}" exact v-if="$hasPermission('sasv.list')" link>
          <v-list-item-icon>
            <v-icon>fas fa-copy</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('admin_sasv.duplicate_title') }}</v-list-item-title>
        </v-list-item>
<!--        <v-list-item :to="{name: 'sasv-email-template'}" exact v-if="$hasPermission('sasv.email_templates')" link>-->
<!--          <v-list-item-icon>-->
<!--            <v-icon>mdi-email-outline</v-icon>-->
<!--          </v-list-item-icon>-->
<!--          <v-list-item-title>{{ $t('admin_sasv.email_templates') }}</v-list-item-title>-->
<!--        </v-list-item>-->
        <v-list-item :to="{name: 'sasv-tnc'}" exact v-if="$hasPermission('sasv.tnc')" link>
          <v-list-item-icon>
            <v-icon>fas fa-align-left</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('admin_tnc.title') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <router-view class="sasv-admin-main"></router-view>
  </v-container>
</template>

<script>
export default {
  name: 'SasvView',
  components: {},
}
</script>

<style lang="less">
.sasv {
  height: 100%;
  display: flex;

  .sasv-admin-main {
    overflow: scroll;
  }
}
</style>
